export default __webpack_public_path__ + "static/media/promptengineering.02968b71.svg";